import React, { useRef, useState } from 'react';
import { clsx } from 'clsx';
import { shouldUseLocal } from '../Skeleton/localDev/index.js';
import { NOOP } from '../Skeleton/helpers/index.js';
import useMFRender from '../useMFRender/index.js';
import classes from './styles.module.scss.js';

function MFContainer({ id, mfName, wrapperClassName, containerClassName, loaderClassName, style = {}, data = {}, skeleton, centered = true, onRender = NOOP, onUnmount = NOOP, loader, }) {
    const containerRef = useRef(null);
    const [isShowBanner, setShowBanner] = useState(shouldUseLocal(mfName));
    useMFRender({
        mfName,
        containerRef,
        data,
        skeleton,
        onRender,
        onUnmount,
    });
    return (React.createElement("div", { className: clsx(classes.wrapper, wrapperClassName), style: style },
        isShowBanner && (React.createElement("div", { className: classes.useLocalDevMf, onClick: () => setShowBanner(false) }, "Local dev")),
        React.createElement("div", { id: id, ref: containerRef, className: clsx({ [classes.containerCentered]: centered }, containerClassName) },
            React.createElement("div", { className: clsx(classes.loader, loaderClassName) }, loader))));
}

export { MFContainer as default };
